export default "__VITE_ASSET__CoMhH_Eu__"